import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from 'redux';
import * as NotesActionCreator from "../../../redux/creators/notes";
import { translate } from "../../base/Translation";

import eventManager from "../../base/Events";

const WAIT_INTERVAL = 100;

class Note extends React.Component {

    componentDidMount() {
        this.timer = null;
        this.changed = false;
        window.addEventListener("formSaved", this.handleFormSaved);
    }

    componentWillUnmount() {
        window.removeEventListener("formSaved", this.handleFormSaved);
    }

    handleFormSaved = (event) => {
        this.changed = false;
        this.forceUpdate();
    }

    onChange(evt) {
        clearTimeout(this.timer);

        this.timer = setTimeout(this.updateNote.bind({ component: this, value: evt.target.value }), WAIT_INTERVAL);

        eventManager.trigger("notes_changed", { form: this.form });
    }

    updateNote() {
        this.component.props.onNoteChange(
            this.value,
            this.component.props.question,
            this.component.props.form,
            this.component.props.test
        );

        if (!this.component.changed) {
            this.component.changed = true;
        }
    }

    getNote() {
        const isUndef = typeof this.props.notes[this.props.question] !== "undefined";
        const hasValue = !isUndef || this.props.notes[this.props.question] === null ? false : true;

        return hasValue ? this.props.notes[this.props.question].text : "";
    }

    render() {
        const hasNote = this.getNote() !== "" ? true : false;
        const display = this.props.show || (this.props.show && !hasNote) || (!this.props.show && hasNote) ? "block" : "none";

        if (this.props.readOnly) {
            return (
                <div className="row questionnaire__sections__section__groups__group__questions__question__note" style={{ display }}>
                    <div className="col-md-12">{this.getNote()}</div>
                </div>
            );
        }

        return (
            <div className="row questionnaire__sections__section__groups__group__questions__question__note" style={{ display }}>
                <div className="col-md-12">
                    <div className="form-group">
                        <label className="control-label">
                            {translate("Poznámka")} {this.changed ? <small style={{ color: "red", paddingLeft: "10px"}}>{translate("Nezabudnite uložiť svoje zmeny")}</small> : ""}
                        </label>
                        <textarea className="form-control" style={this.changed ? {borderColor: "red"} : {}} defaultValue={this.getNote()} onChange={this.onChange.bind(this)} />
                    </div>
                </div>
            </div>
        )
    }
}


function matchDispatchToProps(dispatch) {
    return bindActionCreators({
        onNoteChange: NotesActionCreator.noteChangeAction
    }, dispatch);
}

export default connect(state => ({ notes: state.notes }), matchDispatchToProps)(Note);


// WEBPACK FOOTER //
// ./src/modules/form/view.1/Note.jsx